import { render } from "./PrivacyPage.vue?vue&type=template&id=4015fd1e&scoped=true"
const script = {}

import "./PrivacyPage.vue?vue&type=style&index=0&id=4015fd1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4015fd1e"]])

export default __exports__